import styled from 'styled-components';

export const StyledOption = styled.li`
  font-size: 16px;
  min-height: 24px !important;
  gap: 8px;

  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
`;

export const StyledUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const StyledUserName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledUserEmail = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  line-height: 143%;
  letter-spacing: 0.17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
